export default function (maxValue) {
	return `
		<span ${this.html.classAttr('field__charsCounter')} ${this.html.dataAttr({charsCounter: maxValue})}>
			<span ${this.html.classAttr('field__charsCounterValue')} ${this.html.dataAttr({charsCounterValue: null})}>${this.escape(maxValue)}</span>
		</span>
	`;
}
